import type { AxiosError } from "axios";

import { axios } from "~/core/axios";
import type {
  BackendApiErrorResponse,
  BackendApiResponse,
} from "~/core/types/backend-api-response.type";
import type { BaseAttribute } from "~/core/types/common.type";

export const getOpportunityAttributesByViewId = async (view_id?: string) => {
  if (!view_id) return [];
  try {
    const { data } = await axios.get<BackendApiResponse<BaseAttribute[]>>(
      `/opportunity-attributes/views/${view_id}`,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    if (err.response) {
      console.error(err.response.data);
    }
    return [];
  }
};

export const getOpportunityAttributesByPipelineId = async (
  pipeline_id?: string,
) => {
  if (!pipeline_id) return [];
  try {
    const { data } = await axios.get<BackendApiResponse<BaseAttribute[]>>(
      `/opportunity-attributes/pipelines/${pipeline_id}`,
    );

    return data.data;
  } catch (error) {
    const err = error as AxiosError<BackendApiErrorResponse>;
    if (err.response) {
      console.error(err.response.data);
    }
    return [];
  }
};
